<!-- Auditoría → Movimiento de insumos: busca por etiqueta, código o lote y
     muestra la línea de tiempo de cada pieza. -->

@if (isSlowConnection) {
  <div class="alert">⚠ La conexión de internet es lenta.</div>
}

<app-page-title [title]="pageLabel()" backRoute="/audit/menu" backTooltip="Regresar al menú de auditoría"></app-page-title>
<app-page-loader [load]="pageLoad" [label]="pageLabel()" (retry)="init()"></app-page-loader>

<!-- Búsqueda -->
<div class="filter-bar filter-bar--flush">
  <div class="filter-card">
    <mat-button-toggle-group [(ngModel)]="termType" class="type-toggle" [hideSingleSelectionIndicator]="true" aria-label="Buscar por">
      @for (t of termTypes; track t.id) {
        <mat-button-toggle [value]="t.id"><mat-icon>{{ t.icon }}</mat-icon>{{ t.label }}</mat-button-toggle>
      }
    </mat-button-toggle-group>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="filter-card__wide">
      <mat-label>{{ currentHint }}</mat-label>
      <input matInput [(ngModel)]="termValue" (keyup.enter)="addTerm()" [maxlength]="termType === 'tag' ? 200 : 400" autocomplete="off"
             placeholder="Puedes pegar varios separados por coma">
      @if (termValue) {<button matSuffix mat-icon-button aria-label="Limpiar" (click)="termValue = ''"><mat-icon>close</mat-icon></button>}
    </mat-form-field>

    <button mat-stroked-button (click)="addTerm()" [disabled]="loading || !termValue.trim()"><mat-icon>add</mat-icon>Agregar</button>
    <button mat-raised-button color="accent" (click)="search()" [disabled]="loading || (terms.length === 0 && !termValue.trim())"><mat-icon>search</mat-icon>Buscar</button>
    <button mat-icon-button (click)="reset()" [disabled]="loading" matTooltip="Empezar de nuevo"><mat-icon>refresh</mat-icon></button>
  </div>

  @if (terms.length > 0) {
    <div class="filter-chips">
      <span class="filter-chips__count">{{ terms.length }} por consultar:</span>
      @for (term of terms; track $index) {
        <span class="filter-chip">
          <b class="pill__type">{{ typeLabel(term.type) }}:</b>&nbsp;
          {{ term.value }}
          <button type="button" class="filter-chip__remove" (click)="removeTerm($index)" matTooltip="Quitar"><mat-icon>close</mat-icon></button>
        </span>
      }
    </div>
  }
</div>

<div class="list-actions">
  <button mat-stroked-button (click)="downloadTemplate()"><mat-icon>download_for_offline</mat-icon>Plantilla</button>
  <button mat-stroked-button (click)="uploadTerms()" [disabled]="loading"><mat-icon>upload</mat-icon>Cargar Excel</button>
  @if (pieces.length > 0) {
    <button mat-flat-button color="primary" (click)="downloadReport()"><mat-icon>download</mat-icon>Descargar Excel</button>
  }
</div>

@if (loading) {
  <div class="loading-row"><mat-spinner diameter="32"></mat-spinner><span>Buscando piezas y movimientos...</span></div>
} @else if (pieces.length > 0) {

  <!-- Indicadores -->
  <div class="kpis">
    <div class="kpi"><mat-icon>inventory_2</mat-icon><div><div class="kpi__value">{{ kpis.pieces }}</div><div class="kpi__label">Piezas encontradas</div></div></div>
    <div class="kpi"><mat-icon>{{ productsIcon }}</mat-icon><div><div class="kpi__value">{{ kpis.products }}</div><div class="kpi__label">Insumos distintos</div></div></div>
    <div class="kpi"><mat-icon>layers</mat-icon><div><div class="kpi__value">{{ kpis.batches }}</div><div class="kpi__label">Lotes distintos</div></div></div>
    <div class="kpi"><mat-icon>timeline</mat-icon><div><div class="kpi__value">{{ kpis.moves }}</div><div class="kpi__label">Movimientos</div></div></div>
  </div>

  @if (truncated || notFoundCodes.length > 0) {
    <div class="alert">
      @if (truncated) { Se muestran las primeras 500 piezas; agrega más criterios para acotar. }
      @if (notFoundCodes.length > 0) { Código(s) que no existen en el catálogo: <b>{{ notFoundCodes.join(', ') }}</b>. }
    </div>
  }

  <!-- Filtros sobre el resultado -->
  <div class="results-bar">
    <div class="status-chips">
      @for (s of statusCounts; track s.status) {
        <button type="button" class="st-chip {{ statusClass(s.status) }}" [class.st-chip--on]="statusFilter === s.status" (click)="toggleStatus(s.status)">
          {{ s.status }} <b>{{ s.count }}</b>
        </button>
      }
    </div>
    <div class="results-tools">
      <app-search-pill class="results-filter" [value]="filterText" placeholder="Código, lote, RFID, ubicación…" (valueChange)="filterText = $event"></app-search-pill>
      <mat-button-toggle-group class="view-toggle" [value]="listView.mode" (change)="listView.set($event.value)" [hideSingleSelectionIndicator]="true" aria-label="Vista">
      <mat-button-toggle value="table" matTooltip="Vista de tabla"><mat-icon>table_rows</mat-icon></mat-button-toggle>
      <mat-button-toggle value="cards" matTooltip="Vista de tarjetas"><mat-icon>grid_view</mat-icon></mat-button-toggle>
    </mat-button-toggle-group>
    </div>
  </div>

  @if (listView.mode === 'table') {
    <div class="table-container mat-elevation-z2 pieces-table">
      <table>
        <tr>
          <th></th><th>Código</th><th>Descripción</th><th>RFID</th><th>Lote</th><th>Caducidad</th><th>Ubicación</th><th>Último movimiento</th><th>Estado</th>
        </tr>
        @for (p of shown; track p.id) {
          <tr class="pieces-table__row" [class.pieces-table__row--open]="p._open">
            <td><button mat-icon-button (click)="p._open = !p._open" [matTooltip]="p._open ? 'Ocultar movimientos' : 'Ver movimientos'"><mat-icon>{{ p._open ? 'expand_less' : 'expand_more' }}</mat-icon></button></td>
            <td><b>{{ p.code }}</b></td>
            <td>{{ p.description }}</td>
            <td class="mono">{{ p.tagRfid || '—' }}</td>
            <td>{{ p.batch || '—' }}</td>
            <td>{{ p.expiration || '—' }}</td>
            <td>{{ p.warehouse || '—' }}@if (p.place) { · {{ p.place }} }</td>
            <td>
              @if (p.moves.length > 0) {
                {{ p.moves[p.moves.length - 1].label }}<br><small>{{ formatDate(p.moves[p.moves.length - 1].date) }} · {{ p.moves.length }} mov.</small>
              } @else { — }
            </td>
            <td>
              @if (!p.editing) {
                <button type="button" class="st-badge {{ statusClass(p.status) }}" [disabled]="!isAdmin" (click)="p.editing = true" [matTooltip]="isAdmin ? 'Cambiar estado' : ''">{{ p.status }}</button>
              } @else {
                <div class="piece__edit">
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-label>Estado</mat-label>
                    <mat-select [(ngModel)]="p.newStatus">
                      @for (s of ['Disponible', 'Transito', 'Maleta', 'Consumido', 'Caduco']; track s) {
                        <mat-option [value]="s">{{ s }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <button mat-icon-button color="accent" (click)="saveStatus(p)" matTooltip="Guardar"><mat-icon>save</mat-icon></button>
                  <button mat-icon-button (click)="p.editing = false; p.newStatus = p.status" matTooltip="Cancelar"><mat-icon>close</mat-icon></button>
                </div>
              }
            </td>
          </tr>
          @if (p._open) {
            <tr class="pieces-table__detail">
              <td colspan="9">
                @if (p.moves.length > 0) {
                  <ol class="timeline">
                    @for (m of p.moves; track $index) {
                      <li class="timeline__item timeline__item--{{ m.kind }}">
                        <mat-icon>{{ kindIcon(m.kind) }}</mat-icon>
                        <div class="timeline__body">
                          <div class="timeline__top"><b>{{ m.label }}</b>@if (m.document) { <code class="folio-badge">{{ m.document }}</code> }</div>
                          @if (m.detail) { <div class="timeline__detail">{{ m.detail }}</div> }
                          <div class="timeline__when">{{ formatDate(m.date) }}@if (m.user) { · {{ m.user }} }</div>
                        </div>
                      </li>
                    }
                  </ol>
                } @else {
                  <p class="piece__empty">Sin movimientos registrados.</p>
                }
              </td>
            </tr>
          }
        }
      </table>
    </div>
  }

  <!-- Piezas -->
  <div class="pieces-grid" [hidden]="listView.mode !== 'cards'">
    @for (p of shown; track p.id) {
      <article class="piece">
        <header class="piece__head">
          <div class="piece__title">
            <b><mat-icon class="dt-icon">{{ productsIcon }}</mat-icon>{{ p.code }}</b>
            <span>{{ p.description }}</span>
          </div>
          @if (!p.editing) {
            <button type="button" class="st-badge {{ statusClass(p.status) }}" [disabled]="!isAdmin" (click)="p.editing = true"
                    [matTooltip]="isAdmin ? 'Cambiar estado' : ''">{{ p.status }}</button>
          }
        </header>

        @if (p.editing) {
          <div class="piece__edit">
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>Estado</mat-label>
              <mat-select [(ngModel)]="p.newStatus">
                @for (s of ['Disponible', 'Transito', 'Maleta', 'Consumido', 'Caduco']; track s) {
                  <mat-option [value]="s">{{ s }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <button mat-icon-button color="accent" (click)="saveStatus(p)" matTooltip="Guardar"><mat-icon>save</mat-icon></button>
            <button mat-icon-button (click)="p.editing = false; p.newStatus = p.status" matTooltip="Cancelar"><mat-icon>close</mat-icon></button>
          </div>
        }

        <dl class="piece__meta">
          <div class="full"><dt><mat-icon class="dt-icon">contactless</mat-icon>RFID</dt><dd class="mono">{{ p.tagRfid || '—' }}</dd></div>
          <div><dt>Lote</dt><dd>{{ p.batch || '—' }}</dd></div>
          <div><dt>No. de delivery</dt><dd>{{ p.deliveryFolio || '—' }}</dd></div>
          <div><dt>Caducidad</dt><dd>{{ p.expiration || '—' }}</dd></div>
          <div><dt>Ubicación</dt><dd>{{ p.warehouse || '—' }}@if (p.place) { · {{ p.place }} }</dd></div>
        </dl>

        @if (p.moves.length > 0) {
          <ol class="timeline">
            @for (m of p.moves; track $index) {
              <li class="timeline__item timeline__item--{{ m.kind }}">
                <mat-icon>{{ kindIcon(m.kind) }}</mat-icon>
                <div class="timeline__body">
                  <div class="timeline__top">
                    <b>{{ m.label }}</b>
                    @if (m.document) { <code class="folio-badge">{{ m.document }}</code> }
                  </div>
                  @if (m.detail) { <div class="timeline__detail">{{ m.detail }}</div> }
                  <div class="timeline__when">{{ formatDate(m.date) }}@if (m.user) { · {{ m.user }} }</div>
                </div>
              </li>
            }
          </ol>
        } @else {
          <p class="piece__empty">Sin movimientos registrados.</p>
        }
      </article>
    }
  </div>

  @if (filtered.length > shown.length) {
    <div class="more"><button mat-stroked-button (click)="showMore()"><mat-icon>expand_more</mat-icon>Ver más ({{ filtered.length - shown.length }})</button></div>
  }
  @if (filtered.length === 0) {
    <div class="no-data"><mat-icon>filter_alt_off</mat-icon><span>Ninguna pieza coincide con el filtro.</span></div>
  }

} @else if (searched) {
  <div class="no-data panel">
    <mat-icon>search_off</mat-icon>
    <span>No se encontraron piezas con esos criterios.</span>
    @if (notFoundCodes.length > 0) { <span>Código(s) que no existen en el catálogo: <b>{{ notFoundCodes.join(', ') }}</b></span> }
  </div>
} @else {
  <div class="no-data panel">
    <mat-icon>manage_search</mat-icon>
    <span>Elige si buscas por <b>RFID</b>, <b>código</b> o <b>lote</b>, agrega uno o varios valores (o carga un Excel) y presiona <b>Buscar</b>.</span>
  </div>
}
